import React, { useContext } from "react";
import themeContext from "../context/themeContext";
import parse from "html-react-parser";
import { Row, Col } from "antd";
export default function MyFooter() {
  const ctxtheme = useContext(themeContext);
  return (
    <Row style={{ background: `rgba(0,0,107, 0.9)` }}>
      <Col span={24} style={{ color: "white" }}>
        <div align="center">©2022 онд хөгжүүлэв.</div>
      </Col>
    </Row>
  );
}
